export default __webpack_public_path__ + "static/media/RSA.00a67a2e.svg";